export const guidEmpty = () => {
    return '00000000-0000-0000-0000-000000000000'
}
export const guidEmptyOne = () => {
    return '00000000-0000-0000-0000-000000000001'
}